﻿import { debounce } from "lodash";
import * as IProduct from './Interfaces'
import slugify from "slugify";
import { Supplier } from "./Interfaces";
import { roundCents } from "../../helpers/Pricing";
import moment from "moment";

export function calculateTotals(products: IProduct.Product[], vatRate: number, clubVatRegistered: boolean, marketDayFee: number, cart: IProduct.ShopCart): { items: number; itemTotal: number; total: number; vat: number; marketDayFee: number } {
    const totals = products.reduce((t, p) => p.variants.reduce((tv, v) => {
        const item = cart.products.find(x => x.productVariantId === v.id);
        if (item) {
            tv.itemTotal += item.quantity * v.price;
            tv.items += item.quantity;
            tv.vat += clubVatRegistered && !p.vatZeroRate ? (item.quantity * v.price / 100 * vatRate) : 0;
        }        

        return tv;
    }, t), { items: 0, itemTotal: 0, vat: 0, total: 0, marketDayFee: 0 });

    totals.itemTotal = roundCents(totals.itemTotal);
    totals.total = totals.itemTotal + marketDayFee;
    totals.vat += clubVatRegistered ? marketDayFee / 100 * vatRate : 0;
    
    totals.vat = roundCents(totals.vat);
    totals.marketDayFee = marketDayFee;

    return totals;
}

export const syncCartsLocal = async (carts: IProduct.ShopCart[]) => {
    if (window.localStorage) {
        try {
            const json = JSON.stringify(carts);
            window.localStorage.setItem('_fhcart', json);
        }
        catch (e) {
            //ignore error, only impact syncing to other tabs
        }
    }
};

export const syncCart = debounce(async (carts: IProduct.ShopCart[], cart: IProduct.ShopCart, confirm: boolean) => {
    syncCartsLocal(carts);

    const url = confirm ? `/Cart/ConfirmOrder/${cart.windowId}` : `/Cart/UpdateCart/${cart.windowId}`;

    const response = await fetch(url, {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(cart.products)
    }); 
}, 500, { leading: true, trailing: true });

export async function cancelOrder(cart: IProduct.ShopCart) {
    const response = await fetch(`/Cart/CancelOrder/${cart.windowId}`, {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: ''
    });    
}

export function filterProductsByCategories(products: IProduct.Product[], ids: number[]) {
    return products.filter(x => x.categories.filter(y => ids.indexOf(y) !== -1).length > 0);
}

export function filterProductsBySupplier(products: IProduct.Product[], suppliers: Supplier[], supplier: string) {
    const original = suppliers.find(x => x.slug === supplier);

    if (original) {
        return { title: original.name, products: products.filter(x => x.supplierId === original.id) };
    }
    else
        return { title: 'All', products };
}

export function filterProductsByNewOrFeatured(products: IProduct.Product[], includeNew = false, includeFeatured = true) {
    return products.filter(x => (includeNew && x.new) || (includeFeatured && x.featured));
}

export const getShopWindowLabel = (window: IProduct.ShopWindow) => {
    const collection = moment(window.market);
    if (window.name) {
        return `${window.name} (Market: ${collection.format('dddd, MMMM Do YYYY')})`;
    }

    return `Market: ${collection.format('dddd, MMMM Do YYYY')}`;
}